import { Button as MuiButton, ButtonProps, SimplePaletteColorOptions } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';

const StyledButton = styled(MuiButton)((props) => {
  const {
    color,
    variant,
    theme: { palette },
  } = props;

  const paletteColor = palette[color as keyof typeof palette] as SimplePaletteColorOptions;

  const border = variant !== 'text' ? `2px solid ${paletteColor.main}` : '0';

  return `
  border: ${border};
  ${props.size === 'small' && 'padding: 0.6rem 1.2rem'}

  :hover {
    background-color: ${paletteColor.extraLight};
    color: ${paletteColor.main};
    border: ${border};
  }
  `;
});

export const Button = (props: ButtonProps) => {
  const { variant = 'contained', color = 'primary', ...args } = props;
  return <StyledButton variant={variant} color={color} {...args} />;
};
